import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';

type JotformWindow = Window & {
  jotformEmbedHandler?: (selector: string, origin: string) => void;
};

@Component({
  selector: 'app-ticket-system',
  standalone: true,
  imports: [],
  templateUrl: './ticket-system.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ticket-system.component.scss'
})
export class TicketSystemComponent implements AfterViewInit {
  private readonly platformId = inject(PLATFORM_ID);

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const jotformWindow = window as JotformWindow;
    const initializeEmbed = () => jotformWindow.jotformEmbedHandler?.(
      "iframe[id='JotFormIFrame-241746539253361']",
      'https://form.jotform.com/'
    );

    const existingScript = document.querySelector<HTMLScriptElement>('script[data-jotform-embed-handler]');
    if (existingScript) {
      if (jotformWindow.jotformEmbedHandler) {
        initializeEmbed();
      } else {
        existingScript.addEventListener('load', initializeEmbed, { once: true });
      }
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
    script.async = true;
    script.dataset['jotformEmbedHandler'] = 'true';
    script.addEventListener('load', initializeEmbed, { once: true });
    document.head.appendChild(script);
  }

}
